// @flow
import * as React from 'react';
import type { SvgComponentProps } from '~/core/icons/svg-icons/types';

const LightRainShowers = ({ fill, svgComponents: { G, Path } }: SvgComponentProps) => {
    const gProps = fill ? { fill } : {};
    return (
        <G {...gProps}>
            <Path d="M22.6,32.24h0a.86.86,0,0,0,.75-.43h0A.87.87,0,0,0,23,30.62h0a.87.87,0,0,0-1.19.31h0a.87.87,0,0,0,.32,1.19A.88.88,0,0,0,22.6,32.24Z" />
            <Path d="M24.34,29.23h0a.86.86,0,0,0,.75-.43h0a.86.86,0,0,0-.31-1.18h0a.87.87,0,0,0-1.19.31h0a.87.87,0,0,0,.76,1.3Z" />
            <Path d="M26.08,26.22h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.87.87,0,0,0-1.19.32h0a.86.86,0,0,0,.32,1.18A.8.8,0,0,0,26.08,26.22Z" />
            <Path d="M15.22,36h0a.89.89,0,0,0,.76-.43h0a.88.88,0,0,0-.32-1.19h0a.87.87,0,0,0-1.19.32h0a.87.87,0,0,0,.32,1.18A.88.88,0,0,0,15.22,36Z" />
            <Path d="M17,33h0a.88.88,0,0,0,.76-.43h0a.87.87,0,0,0-.32-1.18h0a.87.87,0,0,0-1.19.31h0A.87.87,0,0,0,17,33Z" />
            <Path d="M18.7,30h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.88.88,0,0,0-1.19.32h0a.86.86,0,0,0,.32,1.18A.89.89,0,0,0,18.7,30Z" />
            <Path d="M20.43,27h0a.85.85,0,0,0,.75-.43h0a.86.86,0,0,0-.31-1.18h0a.87.87,0,0,0-1.19.31h0a.87.87,0,0,0,.76,1.3Z" />
            <Path d="M22.17,24h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.88.88,0,0,0-1.19.32h0a.87.87,0,0,0,.76,1.3Z" />
            <Path d="M12.19,32.24h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.87.87,0,0,0-1.19.32h0a.87.87,0,0,0,.32,1.18A.88.88,0,0,0,12.19,32.24Z" />
            <Path d="M13.92,29.23h0a.86.86,0,0,0,.75-.43h0a.86.86,0,0,0-.31-1.18h0a.87.87,0,0,0-1.19.31h0a.87.87,0,0,0,.76,1.3Z" />
            <Path d="M15.66,26.22h0a.86.86,0,0,0,.75-.43h0a.87.87,0,0,0-.31-1.19h0a.88.88,0,0,0-1.19.32h0a.86.86,0,0,0,.32,1.18A.89.89,0,0,0,15.66,26.22Z" />
            <Path d="M23.51,7.5A.5.5,0,0,1,23,7V4.5a.5.5,0,0,1,1,0V7A.5.5,0,0,1,23.51,7.5Z" />
            <Path d="M35.5,16.65H33a.5.5,0,0,1,0-1h2.5a.5.5,0,0,1,0,1Z" />
            <Path d="M17.06,10.2a.5.5,0,0,1-.35-.15L14.94,8.28a.5.5,0,0,1,.71-.71l1.77,1.77a.5.5,0,0,1-.35.85Z" />
            <Path d="M30,10.2a.5.5,0,0,1-.35-.85l1.77-1.77a.5.5,0,1,1,.71.71l-1.77,1.77A.5.5,0,0,1,30,10.2Z" />
            <Path d="M30.87,18l-1-.12a6.45,6.45,0,0,0-12.08-3.79l-.88-.47a7.45,7.45,0,0,1,14,3.53A7.56,7.56,0,0,1,30.87,18Z" />
            <Path d="M26.73,30.87h-.85a.5.5,0,0,1,0-1h.85a6.23,6.23,0,1,0-3.86-11.11l-.49.39-.27-.57a7.91,7.91,0,1,0-11.85,9.74.5.5,0,1,1-.59.8A8.91,8.91,0,1,1,22.73,17.62a7.23,7.23,0,1,1,4,13.25Z" />
        </G>
    );
};

export default LightRainShowers;



// WEBPACK FOOTER //
// ./src/core/icons/svg-icons/weather/light-rain-showers/index.js